import logoUrl from '~/assets/images/logo.png';
import { UserRole } from '~/services/login';

export const DefaultIconUrl = logoUrl;

export const THEME_COLOR = '#5c89ff'; // --primary-light

export const USER_TYPE = ['NORMAL', 'VIP', 'SVIP', 'SVIP'];
export const USER_TYPE_TEXT = ['普通用户', 'VIP', 'SVIP', 'SVIP'];

// 判断是否为开发环境
export const isDevelopment = import.meta.env.DEV || process.env.NODE_ENV === 'development';

// 判断是否启用Mock
export const isMockEnabled = !!import.meta.env.VITE_MOCK;

// 判断是否为生产环境
export const isProduction = import.meta.env.PROD || process.env.NODE_ENV === 'production';

// 判断用户是否为创作者或在开发环境中
export const isCreatorOrDev = (userRole?: UserRole): boolean => {
  return userRole === UserRole.Creater || isDevelopment;
};

// 小屏自适应分界线（移动设备）
export const ScreenBreakpoint = 992; // 自定义断点

export const G_EmptyStr = '-';

/* eslint-disable-next-line */
export const REGEX = /^[^\/&"?<>#{}%~=\'\[\\\]\|\+]*$/;
export const getRegexDesc = (name: string = '该输入项') => {
  /* eslint-disable-next-line */
  return `${name}不允许包含 \/&"?<>#{}%~=\'\[\\\]\|\+ 等特殊字符`;
};

export const PluginIDHashMap: any = {
  // 剪映小助手
  '7522412867740565513': '7576197995168022547', // create_draft
  // 剪映小助手数据生成器
  '7475829177439109155': '7576197995168022547', // add_images
  // 视频合成_剪映小助手
  '7457837925833801768': '7576197995168022547', // str_list_to_objs

  
  'e475829177439109155': '7576197995168022547', // add_masks
  'e576197995168022247': '7576197995168022547', // add_videos
  'e576197995168022348': '7576197995168022547', // easy_create_material
  'e522412867740565313': '7576197995168022547', // get_image_animations
  'e475829177439109455': '7576197995168022547', // audio_timelines
  'e576197995168022647': '7576197995168022547', // video_infos
  'e576197995168022748': '7576197995168022547', // str_to_list
};
